<template>
    <BaseLink :to="to">
        <button
            :class="$style.tag_button"
            data-interface-target="tag"
        >
            <Typography
                type="label"
                size="s"
                accent
                :responsive="false"
            >
                {{ props.name }}
                <span
                    v-if="props.count"
                    :class="$style.tag_count"
                >
                    {{ props.count }}
                </span>
            </Typography>
        </button>
    </BaseLink>
</template>

<script setup lang="ts">
import { RouteLocationRaw } from 'vue-router'

import BaseLink from '@/components/BaseLink.vue'
import Typography from '@/components/Typography.vue'

const props = defineProps<{ to: RouteLocationRaw; name: string; count?: number }>()
</script>
<style module>
.tag_button {
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: var(--purple-600);
    border-radius: 1000px;
    padding: 9px 12px;
    background: var(--carbon-400);
    font-weight: var(--font-weight-accent);
}

.tag_button:hover {
    background-color: var(--purple-400);
    border-color: var(--purple-400);
}

.tag_button:active {
    border-color: var(--purple-400);
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.08) 0%, rgba(0, 0, 0, 0.08) 100%), var(--purple-400);
}
.tag_button:hover .tag_count,
.tag_button:hover,
.tag_button:active .tag_count,
.tag_button:active {
    color: white;
}

.tag_count {
    color: var(--white-40);
}
</style>
